__turbopack_context__.v({
  "scheduledQuestionnaire": "ScheduledQuestionnaire-module__QeJPFa__scheduledQuestionnaire",
});
